export const TOUR_LEAD_MANAGEMENT_DATA_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_DATA_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_DATA_FAIL = "TOUR_LEAD_MANAGEMENT_DATA_FAIL";
export const TOUR_LEAD_MANAGEMENT_DATA = "TOUR_LEAD_MANAGEMENT_DATA";

export const TOUR_LEAD_MANAGEMENT_DETAILS = "TOUR_LEAD_MANAGEMENT_DETAILS";
export const TOUR_LEAD_MANAGEMENT_DETAILS_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_DETAILS_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_DETAILS_FAIL =
  "TOUR_LEAD_MANAGEMENT_DETAILS_FAIL";

export const TOUR_LEAD_MANAGEMENT_UPDATE_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_UPDATE_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_UPDATE_FAIL =
  "TOUR_LEAD_MANAGEMENT_UPDATE_FAIL ";
export const TOUR_LEAD_MANAGEMENT_UPDATE = "TOUR_LEAD_MANAGEMENT_UPDATE";

export const TOUR_LEAD_MANAGEMENT_LIST_ALL_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_LIST_ALL_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_LIST_PENDING_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_LIST_PENDING_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS";

export const TOUR_LEAD_MANAGEMENT_CSV_START = "TOUR_LEAD_MANAGEMENT_CSV_START";
export const TOUR_LEAD_MANAGEMENT_CSV_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_CSV_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_CSV_ERROR = "TOUR_LEAD_MANAGEMENT_CSV_ERROR";
export const TOUR_LEAD_MANAGEMENT_REVIEW = "TOUR_LEAD_MANAGEMENT_REVIEW";
export const TOUR_LEAD_MANAGEMENT_REVIEW_SUCCESS =
  "TOUR_LEAD_MANAGEMENT_REVIEW_SUCCESS";
export const TOUR_LEAD_MANAGEMENT_REVIEW_FAIL =
  "TOUR_LEAD_MANAGEMENT_REVIEW_FAIL";
